// components/Chat/MessageInput.jsx

import { useState } from 'react';
import {
    Box, TextField, Button, Stack
} from '@mui/material';


const MessageInput = ({ categoryId, onSend, nickname, socket }) => {
    const [content, setContent] = useState('');
    const [sending, setSending] = useState(false);

    const handleSubmit = () => {
        const trimmed = content.trim();
        console.log("📡 WebSocket 상태:", socket?.readyState);
        if (!trimmed || !socket || socket.readyState !== 1) return;

        setSending(true);

        try {
            socket.send(JSON.stringify({
                text: trimmed,
                nickname: nickname || '익명'
            }));
            setContent('');
        } catch (err) {
            console.error("WebSocket 메시지 전송 실패:", err);
            alert("메시지 전송에 실패했습니다.");
        } finally {
            setSending(false);
        }
    };

    return (
        <Box>
            <Stack direction="row" spacing={1}>
                <TextField
                    fullWidth
                    size="small"
                    label="메시지를 입력하세요"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            handleSubmit();
                        }
                    }}
                />
                <Button variant="contained" onClick={handleSubmit} disabled={sending}>
                    전송
                </Button>
            </Stack>
        </Box>
    );
};

export default MessageInput;
